import { Types } from 'mongoose';

import { EventType } from '../enumerations';

export class EventInputModel {
  public timestamp = new Date();

  constructor(
    public readonly gid: Types.ObjectId,
    public readonly data: object,
    public readonly type: EventType,
    public readonly author?: Types.ObjectId,
    public readonly former?: object
  ) {}
}
